import clsx from 'clsx';
import React, { useState, useEffect, useRef } from 'react';
import './style.scss';
import { Modal } from 'react-bootstrap';
import Button from '../Shared/components/controls/Button';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
const PopupComponent = (props) => {
  //const data of props
  const {
    heading: modalTitle,
    text: modalBody,
    additionalText: modalDescription,
    cancelButton: modalTextCancel,
    confirmButton: modalTextContinue,
  } = props?.fields;
  //handle modal
  const [showConfirmModal, setConfirmShowModal] = useState(false);
  const handleClose = () => setConfirmShowModal(false);
  //render conditions
  const shouldRenderModalTextCancel = !!modalTextCancel?.value;
  const shouldRenderModalTextContinue = !!modalTextContinue?.value;
  const shouldRenderModalDescription = !!modalDescription?.value;
  const shouldRenderModalTitle = !!modalTitle?.value;
  const shouldRenderModalBody = !!modalBody?.value;
  //references
  const modalRef = useRef(null);
  const [link, setLink] = useState('');
  const [target, setTarget] = useState('');

  //confirm request
  const onConfirm = () => {
    //open the link with the respective target
    window.open(link, target);
    setConfirmShowModal(false);
  };
  //cancel request
  const onCancel = () => {
    setLink('');
    setTarget('');
    setConfirmShowModal(false);
  };
  //put inside PopupComponent
  useEffect(() => {
    //click method declaration
    const clickResponse = (e) => {
      //get link href
      let linkHref = e.currentTarget.attributes.href.value;
      //get target
      let linkTarget = e.currentTarget.attributes.target.value;
      //check if external
      if (linkHref.indexOf(window.location.hostname) === -1) {
        //external
        e.preventDefault();
        setLink(linkHref);
        setTarget(linkTarget);
        //show modal
        setConfirmShowModal(true);
      }
    };
    //get all a tags
    let allATagElements = document.querySelectorAll('a');
    //remove click listener
    for (let i = 0; i < allATagElements.length; i++) {
      allATagElements[i].removeEventListener('click', clickResponse);
    }
    //add click listener
    for (let i = 0; i < allATagElements.length; i++) {
      allATagElements[i].addEventListener('click', clickResponse);
    }
  }, []);
  return (
    //https://react-bootstrap.github.io/components/modal/#vertically-centered

    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={showConfirmModal}
      onHide={handleClose}
      ref={modalRef}
      className={clsx('modal--theme1', 'hidden')}
    >
      <Modal.Body className="modal--theme1">
        <div className="motalTop flex-it flex-justify-end">
          <div className="modalClose" onClick={handleClose}>
            <img src={'/-/jssmedia/Project/FAB2/shared/images/icon_close-blue.svg'} />
          </div>
        </div>

        <div className="modalWrap flex-it ">
          <div className="modalArrowRightUp flex-it flex-align-item-center">
            <img src={'/-/jssmedia/Project/FAB2/shared/images/icon_arrow-right-up.svg'} />
          </div>

          <div className="text">
            {shouldRenderModalTitle && <RichText className="modalTitle" field={modalTitle} />}
            {shouldRenderModalBody && <RichText className="modelBody" field={modalBody} />}
          </div>
        </div>

        <div className="modalButtons flex-it flex-justify-end">
          {shouldRenderModalTextCancel && (
            <Button onClick={onCancel}>{modalTextCancel?.value}</Button>
          )}
          {shouldRenderModalTextContinue && (
            <Button onClick={onConfirm}>{modalTextContinue?.value}</Button>
          )}
        </div>
        {shouldRenderModalDescription && (
          <RichText className="modalMoreDescription" field={modalDescription} />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default PopupComponent;
